import React from 'react';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import { POWER_CONTROL_UNIT_STATE } from '../../_config/consts';

const PowerStatusBadge = ({ state }) => {
  const getConfig = () => {
    switch (state) {
      case POWER_CONTROL_UNIT_STATE.POWER_ON:
        return {
          color: '#4caf50',
          backgroundColor: '#e8f5e9',
          entity: 'powerOn',
        };
      case POWER_CONTROL_UNIT_STATE.POWER_OFF:
        return {
          color: '#9e9e9e',
          backgroundColor: '#f5f5f5',
          entity: 'powerOff',
        };
      case POWER_CONTROL_UNIT_STATE.GRACE_PERIOD:
        return {
          color: '#ff9800',
          backgroundColor: '#fff3e0',
          entity: 'gracePeriod',
        };
      case POWER_CONTROL_UNIT_STATE.INHIBITED:
        return {
          color: '#f44336',
          backgroundColor: '#ffebee',
          entity: 'inhibited',
        };
      default:
        return {
          color: '#9e9e9e',
          backgroundColor: '#f5f5f5',
          entity: 'powerOff',
        };
    }
  };

  const config = getConfig();

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '4px 12px',
        borderRadius: 16,
        backgroundColor: config.backgroundColor,
        color: config.color,
        fontSize: 13,
        fontWeight: 600,
      }}
    >
      <div
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: config.color,
          marginRight: 6,
        }}
      />
      <Entity entity={config.entity} />
    </div>
  );
};

export default PowerStatusBadge;
